import React from "react";
import { createSvgIcon } from "@mui/material/utils";

const ItFlagIcon = createSvgIcon(
 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2">
  <path fill="#008C45" d="M0 0h1v2H0z" />
  <path fill="#fff" d="M1 0h1v2H1z" />
  <path fill="#CD212A" d="M2 0h1v2H2z" />
 </svg>,
 "Italy"
);

const FrFlagIcon = createSvgIcon(
 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2">
  <path fill="#0055A4" d="M0 0h1v2H0z" />
  <path fill="#FFFFFF" d="M1 0h1v2H1z" />
  <path fill="#EF4135" d="M2 0h1v2H2z" />
 </svg>,
 "France"
);

const DkFlagIcon = createSvgIcon(
 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2">
  <path fill="#C60C30" d="M0 0h3v2H0z" />
  <path fill="#FFF" d="M1.2 0h.6v2h-.6zM0 .8h3v.4H0z" />
 </svg>,
 "Denmark"
);

const USFlagIcon = createSvgIcon(
<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1235" height="650" viewBox="0 0 7410 3900">
 <path d="M0,0h7410v3900H0" fill="#b31942"/>
 <path d="M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0" stroke="#FFF" strokeWidth="300"/>
 <path d="M0,0h2964v2100H0" fill="#0a3161"/>
 <g fill="#FFF">
  <g id="s18">
   <g id="s9">
    <g id="s5">
     <g id="s4">
      <path id="s" d="M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z"/>
      <use xlinkHref="#s" y="420"/>
      <use xlinkHref="#s" y="840"/>
      <use xlinkHref="#s" y="1260"/>
     </g>
     <use xlinkHref="#s" y="1680"/>
    </g>
    <use xlinkHref="#s4" x="247" y="210"/>
   </g>
   <use xlinkHref="#s9" x="494"/>
  </g>
  <use xlinkHref="#s18" x="988"/>
  <use xlinkHref="#s9" x="1976"/>
  <use xlinkHref="#s5" x="2470"/>
 </g>
</svg>,
 "United States"
);

const AuFlagIcon = createSvgIcon(
 <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 10080 5040">
  <defs>
    <clipPath id="b">
      <path d="M0 0h6v3H0z"/>
    </clipPath>
    <clipPath id="c">
      <path d="M0 0v1.5h6V3zm6 0H3v3H0z"/>
    </clipPath>
    <path id="a" d="M0-360l69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z"/>
    <path id="e" d="M0-210L54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z"/>
    <use id="d" xlinkHref="#a" transform="scale(2.1)"/>
  </defs>
  <path fill="#012169" d="M0 0h10080v5040H0z"/>
  <path d="M0 0l6 3m0-3L0 3" stroke="#fff" stroke-width=".6" clip-path="url(#b)" transform="scale(840)"/>
  <path d="M0 0l6 3m0-3L0 3" stroke="#e4002b" stroke-width=".4" clip-path="url(#c)" transform="scale(840)"/>
  <path d="M2520 0v2520M0 1260h5040" stroke="#fff" stroke-width="840"/>
  <path d="M2520 0v2520M0 1260h5040" stroke="#e4002b" stroke-width="504"/>
  <g fill="#fff">
    <use xlinkHref="#d" x="2520" y="3780"/>
    <use xlinkHref="#a" x="7560" y="4200"/>
    <use xlinkHref="#a" x="6300" y="2205"/>
    <use xlinkHref="#a" x="7560" y="840"/>
    <use xlinkHref="#a" x="8680" y="1869"/>
    <use xlinkHref="#e" x="8064" y="2730"/>
  </g>
</svg>,
 "Australia"
);

const UkFlagIcon = createSvgIcon(
 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30">
  <clipPath id="a">
   <path d="M0 0v30h60V0z" />
  </clipPath>
  <clipPath id="b">
   <path d="M30 15h30v15zv15H0zH0V0zV0h30z" />
  </clipPath>
  <g clip-path="url(#a)">
   <path d="M0 0v30h60V0z" fill="#012169" />
   <path d="M0 0l60 30m0-30L0 30" stroke="#fff" stroke-width="6" />
   <path
    d="M0 0l60 30m0-30L0 30"
    clip-path="url(#b)"
    stroke="#C8102E"
    stroke-width="4"
   />
   <path d="M30 0v30M0 15h60" stroke="#fff" stroke-width="10" />
   <path d="M30 0v30M0 15h60" stroke="#C8102E" stroke-width="6" />
  </g>
 </svg>,
 "United Kingdom"
);

const DeFlagIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10080 5040">
    <rect width="10080" height="1680" y="0" fill="#000" />
    <rect width="10080" height="1680" y="1680" fill="#DD0000" />
    <rect width="10080" height="1680" y="3360" fill="#FFCE00" />
  </svg>,
  "Germany"
);

export default [
 {
  name: "Italy",
  icon: ItFlagIcon,
  value: "IT",
 },
 {
  name: "United Kingdom",
  icon: UkFlagIcon,
  value: "UK",
 },
 {
  name: "Australia",
  icon: AuFlagIcon,
  value: "AU",
 },
  {
  name: "Germany",
  icon: DeFlagIcon,
  value: "DE",
 },
 {
  name: "France",
  icon: FrFlagIcon,
  value: "FR",
 },
 {
 name: "Denmark",
 icon: DkFlagIcon,
 value: "DK",
 },
 {
 name: "United States",
 icon: USFlagIcon,
 value: "US",
 }
];
